(function () {
  "use strict";

  var initializedEntries = new WeakSet();

  function initEntry(entry) {
    if (!entry || initializedEntries.has(entry)) return;
    initializedEntries.add(entry);

    var stops = Array.prototype.slice.call(entry.querySelectorAll("[data-kll-entry-stop]"));
    var reduceMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var activeIndex = 0;
    var cycleTimer = null;
    var pointerFrame = null;

    entry.classList.add("has-js");

    function activateStop(index) {
      if (!stops.length) return;

      activeIndex = (index + stops.length) % stops.length;

      stops.forEach(function (stop, stopIndex) {
        stop.classList.toggle("is-active", stopIndex === activeIndex);
      });

      entry.style.setProperty(
        "--kll-entry-route-progress",
        stops[activeIndex].getAttribute("data-route-progress") || "0"
      );
    }

    function stopCycle() {
      if (!cycleTimer) return;
      window.clearInterval(cycleTimer);
      cycleTimer = null;
    }

    function startCycle() {
      stopCycle();
      if (reduceMotion || stops.length < 2 || document.hidden) return;

      cycleTimer = window.setInterval(function () {
        activateStop(activeIndex + 1);
      }, 2600);
    }

    stops.forEach(function (stop, stopIndex) {
      stop.addEventListener("pointerenter", function () {
        stopCycle();
        activateStop(stopIndex);
      });

      stop.addEventListener("focus", function () {
        stopCycle();
        activateStop(stopIndex);
      });
    });

    entry.addEventListener("pointerleave", startCycle);
    entry.addEventListener("focusout", function (event) {
      if (!entry.contains(event.relatedTarget)) startCycle();
    });

    if (!reduceMotion) {
      entry.addEventListener("pointermove", function (event) {
        if (pointerFrame) window.cancelAnimationFrame(pointerFrame);

        pointerFrame = window.requestAnimationFrame(function () {
          var bounds = entry.getBoundingClientRect();
          var x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
          var y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));

          entry.style.setProperty("--kll-entry-pointer-x", (x * 100).toFixed(2) + "%");
          entry.style.setProperty("--kll-entry-pointer-y", (y * 100).toFixed(2) + "%");
          entry.style.setProperty("--kll-entry-parallax-x", ((x - 0.5) * -12).toFixed(2) + "px");
          entry.style.setProperty("--kll-entry-parallax-y", ((y - 0.5) * -8).toFixed(2) + "px");
        });
      });
    }

    function reveal() {
      entry.classList.add("is-visible");
      activateStop(0);
      startCycle();
    }

    if (reduceMotion || !("IntersectionObserver" in window)) {
      reveal();
    } else {
      var observer = new IntersectionObserver(function (items) {
        items.forEach(function (item) {
          if (!item.isIntersecting) return;
          observer.unobserve(entry);
          reveal();
        });
      }, {
        threshold: 0.2,
        rootMargin: "0px 0px -8% 0px"
      });

      observer.observe(entry);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopCycle();
      else if (entry.classList.contains("is-visible")) startCycle();
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches("[data-kll-august-entry]")) {
      initEntry(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll("[data-kll-august-entry]"),
      initEntry
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
